import clsx from "clsx"
import { useMemo } from "react"

type AlertProps = Omit<React.ComponentProps<"div">, "children"> & {
    type?: "error" | "warning" | "success"
    error?: string
}

export function Alert({
    type = "error",
    error,
    className,
    ...props
}: AlertProps) {
    const style = useMemo(() => {
        switch (type) {
            default:
            case "error":
                return "bg-red-700 text-bonza-pale"
            case "warning":
                return "bg-orange-700 text-bonza-pale"
            case "success":
                return "bg-green-600 text-bonza-pale"
        }
    }, [type])

    return (
        <div
            className={`
                w-full rounded-xl px-4 py-2 text-sm

                ${clsx(!error && "hidden")}
                ${style}
                ${className}
            `}
            {...props}
        >
            {error}
        </div>
    )
}
